import React from 'react';
import { Field } from 'react-final-form';
import ListInputs from '@teetsh/app/src/containers/UserSettings/components/ListInputs';

export default function MaterialsSettings() {
  return (
    <Field
      name="materials"
      render={({ input: { value, onChange } }) => (
        <ListInputs items={value} onChange={onChange} />
      )}
    />
  );
}
